export interface BrandLogo {
    logo: string
    name: string
}

enum Brand {
    Woood = 'WOOOD',
    Basiclabel = 'Basiclabel',
    Vtwonen = 'vtwonen',
    BepureHome = 'BePureHome',
    Exotan = 'Exotan',
    PipStudio = 'Pip-Studio',
}

// @TODO: In the future fetch the brands from the API
export const DEFAULT_BRANDS: BrandLogo[] = [
    { name: Brand.Woood, logo: '/assets/images/brands/woood.svg' },
    { name: Brand.Basiclabel, logo: '/assets/images/brands/basiclabel-logo.svg' },
    { name: Brand.Vtwonen, logo: '/assets/images/brands/vtwonen-logo.svg' },
    { name: Brand.BepureHome, logo: '/assets/images/brands/bepurehome-logo.svg' },
    { name: Brand.Exotan, logo: '/assets/images/brands/exotan-logo.svg' },
    { name: Brand.PipStudio, logo: '/assets/images/brands/pip-studio-logo.svg' },
]
